import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import Colors from "assets/Colors";
import { useTranslation } from "react-i18next";

function DocumentPDF({ data }) {
  const { t } = useTranslation();
  const { dateHeader, dataToPrintPdf, currencyFormat } = data;
  return (
    <Document>
      <Page size="A4" style={styles.body} orientation="landscape">
        <View>
          <Text style={styles.date}>
            {t("containers.Operations.Bill.closeOf")}

            {dateHeader}
          </Text>
        </View>

        <View style={{ marginTop: 10 }}>
          <Text style={styles.title}>
            {t("containers.Operations.Bill.pastClosures")}
          </Text>

          <View
            style={[
              styles.row,
              styles.header,
              {
                fontSize: "8px",
                backgroundColor: "#f9f9f9",
              },
            ]}
          >
            <Text style={styles.row1}>
              {t("containers.Operations.opening")}
            </Text>
            <Text style={styles.row1}>
              {t("containers.Operations.closing")}
            </Text>
            <Text style={styles.row1}>{t("containers.Operations.type")}</Text>
            <Text style={styles.row1}>{t("containers.Operations.number")}</Text>
            <Text style={styles.row1}>
              {t("containers.Operations.terminal")}
            </Text>
            <Text style={styles.row1}>
              {t("containers.Operations.grossSales")}
            </Text>
          </View>
          {dataToPrintPdf.map((row, i) => (
            <View key={i} style={styles.row} wrap={false}>
              <Text style={styles.row1}>{row[0]}</Text>
              <Text style={styles.row1}>{row[1]}</Text>
              <Text style={styles.row1}>{row[2]}</Text>
              <Text style={styles.row1}>{row[3]}</Text>
              <Text style={styles.row1}>{row[4]}</Text>
              <Text style={styles.row1}>{currencyFormat(row[5])}</Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
}
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 20,
  },
  itemContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  divider: {
    borderBottomWidth: 0.5,
    borderBottomColor: Colors.background_dividers,
    marginBottom: 15,
  },
  date: {
    fontSize: 7,
    fontWeight: 300,
    marginTop: -20,
    marginBottom: 20,
    textAlign: "right",
  },
  title: {
    fontSize: 7,
    fontWeight: 500,
    marginBottom: 5,
    paddingHorizontal: 10,
  },
  textIfo: {
    fontSize: 7,
    fontWeight: 300,
    marginBottom: 10,
  },
  textIfoName: {
    fontSize: 7,
    fontWeight: 300,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    borderTop: "1px solid #EEE",
    paddingTop: 8,
    paddingBottom: 8,
    marginHorizontal: 10,
  },
  row1: {
    width: "16%",
    fontSize: 7,
    marginLeft: 5,
  },
  row2: {
    width: "25%",
    fontSize: 7,
    marginLeft: 5,
  },
  row3: {
    width: "12%",
    fontSize: 7,
    marginLeft: 5,
  },
  row4: {
    width: "12%",
    fontSize: 7,
    marginLeft: 5,
  },
  row5: {
    width: "12%",
    fontSize: 7,
    marginLeft: 0,
    textAlign: "right",
  },
  row6: {
    width: "12%",
    fontSize: 7,
    marginLeft: 0,
    textAlign: "right",
  },
  containerItems: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  containerPrices: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "70%",
  },
  mapItems: {
    width: "100%",
  },
  items: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
export default DocumentPDF;
